import { Flex, Modal, Space, Table,App} from 'antd';
import React, { useEffect } from 'react'  
import { useState } from 'react'
import {  useBnsXiangMuXuQiuListQuery, useBnsXiangMuXuQiuDelMutation     } from '../../store/BnsKeJiApi';
import ModuleCheck from '../module/ModuleCheck';
import ModuleEdit from '../module/ModuleEdit';
import ModuleAdd from '../module/ModuleAdd';
import ModalDel from '../../cpn/ModalDel';
import ModuleAddCopy from '../module/ModuleAddCopy';

function ClientCheck(props) {
    const {message} = App.useApp()
    const [open,setOpen] = useState()
    const [list,setList] = useState([])
    const [del] = useBnsXiangMuXuQiuDelMutation()
    const columns = [       
        {
            title: '模块',
            dataIndex: 'bxmxq_name',
            key: 'bxmxq_name',
            render:(_,record) => <ModuleCheck
                                    bxmxq_name={record.bxmxq_name}
                                    bxmxq_content={record.bxmxq_content}
                                    bxm_id={record.bxmxq_bxm_id}
                                    bxm_name={record.bxmxq_bxm_name}
                                    bxmxq_id={record.key}
                                    eu_id={props.eu_id} 
                                    eu_name={props.eu_name} 
                                    yh_id={props.yh_id}
                                    yh_name={props.yh_name}
                                />
        },     
        {
          key: 'num',
          title: '编号',            
          dataIndex: 'key',           
      },
      {
          key: 'time',
          title: '操作记录',
          render: (_,record) => {
              return <>{record.bxmxq_ctime + record.bxmxq_cname}</>
          }
      },
      {
          key: 'action',
          title: '操作',
          render: (_, record) => {
              return <>
                    <Space>  
                        <ModuleEdit bxmxq_id={record.key} bxm_id={props.bxm_id} bxm_name={props.bxm_name} eu_id={props.eu_id} eu_name={props.eu_name}/>
                        <ModalDel onOk={() => {
                                                del({bxmxq_id:record.key}).then((res) => {
                                                    console.log(res);
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />  
                        <ModuleAddCopy
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            bxm_id={props.bxm_id}
                            bxm_name={props.bxm_name}
                            eu_id={props.eu_id}
                            eu_name={props.eu_name}
                            bxmxq_name={record.bxmxq_name}
                            bxmxq_content={record.bxmxq_content}
                        />
                        
                    </Space>
              </>
          }
      },     
    ];
    const {data, isSuccess} = useBnsXiangMuXuQiuListQuery({bxmxq_bxm_id:props.bxm_id,bxmxq_yh_id:props.yh_id},{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxmxq_id:key,bxmxq_name,bxmxq_ctime,bxmxq_cname,bxmxq_content,bxmxq_bxm_name,bxmxq_bxm_id} = item;
                    return item = {key,bxmxq_name,bxmxq_ctime,bxmxq_cname,bxmxq_content,bxmxq_bxm_name,bxmxq_bxm_id}
                })                
                let sorrArr = newArr.sort((a, b) => {
                    // 提取bxmbb_name的第一个数字
                    const getFirstNumber = (name) => {
                        if (!name) return 0;
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.bxmbb_name);
                    const numB = getFirstNumber(b.bxmbb_name);
                    
                    return numA - numB;
                });
                setList(sorrArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])  
    return (
        <>
            <a onClick={() => {
                setOpen(true)}}>{props.yh_name}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                width={1000}
                onCancel={() => {setOpen(false);}}                        
                footer={null}
                title={props.bxm_name + ' - ' + props.yh_name + ' - 模块列表'}
            >
                <Flex justify='space-between'>
                    <div dangerouslySetInnerHTML={{__html:props.yh_content}}></div>
                    <ModuleAdd
                        bxm_id={props.bxm_id}
                        bxm_name={props.bxm_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        eu_id={props.eu_id}
                        eu_name={props.eu_name}
                    />
                </Flex>
                <Table
                    columns={columns}
                    dataSource={list}
                    rowKey="key"                    
                    pagination={{
                        pageSize: 10,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
                    }}
                />
            </Modal>
            
        </>
    )
}

export default ClientCheck
